jQuery(document).ready(function () {
  // Home page slider
  $(".testimonial-content").slick({
   slidesToShow: 1,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 5000,
      dots: false, 
     arrows: false, 
  });
  $(".custom-blogs-slider .custom-blogs").slick({
   slidesToShow: 2.6,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 5000,
      dots: false, 
     arrows: false, 
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 2,              
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1, 
              adaptiveHeight: true,
            },
          },
        ],
  });
  
  // shop page slider
  $(".collection-product-list").slick({
   slidesToShow: 3,
   infinite:true,
   slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 5000,
      dots: false, 
     arrows: true, 
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 2,              
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,              
            },
          },
        ],
  });

  // only one collapsible section remains open at a time (for product details page)
  $('.collapsible-sections details').on('toggle', function() {
    if ($(this).prop('open')) {
        $('.collapsible-sections details').not(this).removeAttr('open');
    }
  });

//   $(".header__inline-menu .mega-menu").mouseenter(function() {    
//     $(this).attr("open", true);
// }).mouseleave(function() {    
//     $(this).attr("open", false);
// });

  
  $(".ama-image").on('click', function(){
    window.open('https://www.amazon.com/stores/page/E50A2EEE-42B3-487C-80A5-1F2C63F0C496?maas=maas_adg_71DE6A791BF95A67CE3858BE40405948_afap_abs&ref_=aa_maas&tag=maas', '_blank');
});


});

 function initMobileSlick() {
    if (window.innerWidth <= 767) {
      $('.ingredient-flavor').slick({
        rows: 2,
        slidesToShow: 3,
        slidesToScroll: 2,
        arrows: false,
        dots: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow:3,
              slidesToScroll: 2,
              rows: 2
            }
          }
        ]
      });
    }
  }

  document.addEventListener("DOMContentLoaded", initMobileSlick);
